import { render, staticRenderFns } from "./SettingMemberAttributes.vue?vue&type=template&id=da0e717c"
import script from "./SettingMemberAttributes.vue?vue&type=script&lang=js"
export * from "./SettingMemberAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports